import styled from 'styled-components';

const Container = styled.div<{ orientation: 'column' | 'row' }>`
  display: flex;
  flex-direction: ${({ orientation }) => orientation};

  span {
    font-size: 1.4rem;
    color: #5d4e4f;

    &:first-of-type {
      color: #c4c4c4;
      margin-right: 1rem;
    }
  }
`;

interface Props {
  label: string;
  value: string;
  orientation?: 'column' | 'row';
}

const Info = ({ label, value, orientation = 'row' }: Props) => {
  return (
    <Container orientation={orientation}>
      <span>{label}</span>
      <span>{value}</span>
    </Container>
  );
};

Info.defaultProps = {
  orientation: 'row',
};

export default Info;
